import React, { FC } from "react";
import { Container } from './styles';

export type Props = {
  children?: React.ReactNode;
  color?: 'purple' | 'blue' | 'red' | 'green';
  component?: React.ReactNode;
  disabled?: boolean;
  href?: string;
  onClick?: () => void;
  size?: 'large' | 'medium' | 'small';
  type?: 'submit' | 'button' | 'reset';
  to?: any;
  variant?: 'text' | 'outlined' | 'contained';
};

const Button: FC<Props> = (props) => {
  const MuiProps = {
    ...props,
    component: props.component || 'button',
    className: props.color || 'purple',
    size: props.size,
    color: undefined,
  };

  return (
    <Container {...MuiProps} />
  );
};

export default Button;
